import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import Fire from '../../img/Fire.svg'
import Flood from '../../img/Flood.svg'
import Drought from '../../img/Drought.svg'
import Air from '../../img/Air.svg'
import SvgIcon from '@mui/icons-material/Edit';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function CustomizedMenus() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        // variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <img src={Air} height={'24px'} width={'24px'} aria-label='มลพิษทางอากาศ' />
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component={Link} to="https://disaster.gistda.or.th/flood" disableRipple>
          {/* <SvgIcon component={Flood} viewBox="0 0 67 60" height={'36px'} width={'36px'} color='#FF0000' aria-label='น้ำท่วม' /> */}
          <img src={Flood} height={'24px'} width={'24px'} aria-label='น้ำท่วม' />
          <Typography fontSize={14} marginLeft={'8px'}>น้ำท่วม</Typography>
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="https://disaster.gistda.or.th/fire" disableRipple>
          {/* <SvgIcon component={Fire} viewBox="0 0 47 60" height={'36px'} width={'36px'} color='#FF0000' aria-label='ไฟป่า' /> */}
          <img src={Fire} height={'24px'} width={'24px'} aria-label='ไฟป่า' />
          <Typography fontSize={14} marginLeft={'8px'}>ไฟป่า</Typography>
        </MenuItem>
        {/* <Divider sx={{ my: 0.5 }} /> */}
        <MenuItem onClick={handleClose} component={Link} to="https://disaster.gistda.or.th/drought" disableRipple>
          {/* <SvgIcon component={Drought} viewBox="0 0 75 69" height={'36px'} width={'36px'} color='#FF0000' aria-label='ภัยแล้ง' /> */}
          <img src={Drought} height={'24px'} width={'24px'} aria-label='ภัยแล้ง' />
          <Typography fontSize={14} marginLeft={'8px'}>ภัยแล้ง</Typography>
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="https://air.gistda.or.th/" disableRipple>
          {/* <SvgIcon component={Air} viewBox="0 0 215 207.296" height={'36px'} width={'36px'} color='#FF0000' aria-label='มลพิษทางอากาศ' /> */}
          <img src={Air} height={'24px'} width={'24px'} aria-label='มลพิษทางอากาศ' />
          <Typography fontSize={14} marginLeft={'8px'}>มลพิษทางอากาศ</Typography>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}